angular.module('property-deal')
    .component('propertyDealBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/property-deal/_btn-options.html',
        controller: function (PropertyDealService, FilesLibrary, FilesSimpleUploadService) {
            this.PropertyDealService = PropertyDealService;
            this.FilesLibrary = FilesLibrary;
            this.FilesSimpleUploadService = FilesSimpleUploadService;

            this.canBeBooked = (status) => {
                let acceptableStatuses = ['PRE_BOOKING'];
                return acceptableStatuses.includes(status);
            }
            this.canBeSold = (status) => {
                let acceptableStatuses = ['PRE_BOOKING', 'BOOKED'];
                return acceptableStatuses.includes(status);
            }
            this.canBeTransferred = (status, transfer) => {
                let acceptableStatuses = ['SOLD', 'FINISHED'];
                return transfer == null && acceptableStatuses.includes(status);
            }
            this.canBeFinished = (status, finalContract) => {
                let acceptableStatuses = ['PRE_BOOKING', 'BOOKED', 'SOLD', 'TRANSFERRED'];
                return acceptableStatuses.includes(status) || (finalContract == null && status === 'FINISHED');
            }
            this.cannotBeCancelled = (status) => {
                let NOT_acceptableStatuses = ['CANCELLED'];
                return NOT_acceptableStatuses.includes(status);
            }
            this.canBeDeleted = (status) => {
                let acceptableStatuses = ['CANCELLED'];
                return acceptableStatuses.includes(status);
            }
        }
    })
